import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/admin/Panel";

const LABELS = { bookings_paused: "Bookings deactivated", bookings_resumed: "Bookings reactivated", dates_blocked: "Dates blocked", dates_unblocked: "Dates unblocked",
  booking_cancelled: "Reservation cancelled", refund_issued: "Refund issued", pricing_updated: "Pricing updated", policies_updated: "Policies updated", content_updated: "Content updated", booking_notes_updated: "Booking notes updated" };

const summarize = (d) => Object.entries(d || {}).map(([k, v]) => `${k}: ${Array.isArray(v) ? (v.length > 3 ? `${v[0]} … ${v[v.length - 1]} (${v.length})` : v.join(", ")) : v}`).join(" · ");

export const ActivityLog = () => {
  const [audit, setAudit] = useState(null);
  const [notes, setNotes] = useState(null);
  const loadNotes = () => api.get("/admin/notifications").then((r) => setNotes(r.data));
  const resend = async (key) => {
    try { const { data } = await api.post(`/admin/notifications/${encodeURIComponent(key)}/resend`); toast[data.status === "sent" ? "success" : "error"](data.status === "sent" ? "Email sent" : "Still failing, try again later"); loadNotes(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  useEffect(() => {
    api.get("/admin/audit").then((r) => setAudit(r.data));
    loadNotes();
  }, []);
  return (
    <>
      <Panel title="Email notifications" desc="Every email the system attempted, with the provider's response. Failures are shown in red." testid="notifications-panel">
        {!notes ? <p className="text-sm text-muted-foreground">Loading…</p> : !notes.length ? <p className="text-sm text-muted-foreground" data-testid="notifications-empty">No emails sent yet.</p> : (
          <ul className="divide-y divide-border text-sm">{notes.map((n) => (
            <li key={n.key} className="py-2 flex flex-wrap justify-between gap-2 items-center" data-testid={`notification-${n.key}`}>
              <span>{n.subject} <span className="text-muted-foreground">→ {n.to}</span></span>
              <span className={`text-xs ${n.status === "failed" ? "text-destructive" : "text-muted-foreground"}`}>{n.status}{n.status === "failed" && n.error && `: ${n.error.slice(0, 80)}`} · {new Date(n.created_at).toLocaleString()}
                {n.status === "failed" && <button onClick={() => resend(n.key)} className="ml-2 underline text-foreground" data-testid={`resend-${n.key}`}>Resend</button>}</span>
            </li>))}</ul>
        )}
      </Panel>
      <Panel title="Admin activity log" desc="Sensitive changes with who made them and when." testid="audit-panel">
        {!audit ? <p className="text-sm text-muted-foreground">Loading…</p> : !audit.length ? <p className="text-sm text-muted-foreground" data-testid="audit-empty">No activity yet.</p> : (
          <ul className="divide-y divide-border text-sm">{audit.map((a) => (
            <li key={a.id} className="py-2" data-testid={`audit-${a.action}`}>
              <span className="font-semibold">{LABELS[a.action] || a.action}</span> <span className="text-muted-foreground">by {a.actor} · {new Date(a.created_at).toLocaleString()}</span>
              {summarize(a.details) && <span className="block text-xs text-muted-foreground">{summarize(a.details)}</span>}
            </li>))}</ul>
        )}
      </Panel>
    </>
  );
};
